import React, { Component } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
// import {TableComp} from 'sz-react-utils'
import TableComp from "../../../components/_utils/table";
import { FormUtils as GetAllFormFields, query } from "sz-react-utils";
import { FaUserEdit } from "react-icons/fa";
import moment from "moment";
import ListFollowUps from "../../../components/_utils/listFollowUp";
import { RightsWrapper } from "../../../components/_utils/utils";
import _ from 'lodash'
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Col,
  notification,
  Popconfirm,
  Row,
  Select,
  Tooltip,
  Drawer,
  Form
} from "antd";
import Request, { API_URL, LAPI_URL } from "../../../request";
import Settings from "../../../components/_utils/settings";
import lodash from "lodash";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../common.less";
import LatestFollowUp from "../../../components/_utils/latestFollowup";
import SMS from "../../../components/communication/sms";
import WhatsAPPSMS from "../../../components/communication/WhatsAppSms";
import EmailDrawer from "../../../components/communication/emailDrawer";
import ChangeBranch from "../../Student/inquiry/all/changeBranch";
// import ChangeBranch from "./changeBranch";
import ChangeQuickDetails from "../../Student/inquiry/all/changeQuickDetails";
// import ChangeQuickDetails from "./changeQuickDetails";

import { hideLoader, showLoader } from "../../../modules/actions";

import rightAuth from "../../../components/_utils/userRights";

let counsellingData = {};

let studentObj = {};

const { RangePicker } = DatePicker;

const Option = Select.Option;

let userCheckBox = {};
@Form.create()
class PreviousIncentive extends Component {
  state = {
    count: 0,
    showFollowUp: false,
    studentId: null,
    allDesks: Settings.allDesks,
    deskNameObj: Settings.deskNameObj,
    deskId: "",
    counsellorId: "",
    counsellors: [],
    allCounsellor: [],
    allBranches: [],
    testTypeList: [],
    deleteLoading: false,
    branchId: "",
    deskColor: null,
    userCheckBox: {},
    showSMS: false,
    showIncentiveDrawer: false,
    showWhatsAppSms: false,
    showEmail: false,
    showDate: true,
    selectedCount: 0,
    showRegiDate: false,
    time: {
      key: "time",
      $gte: "",
      $lt: "",
    },
    registrationTime: {
      $gte: "",
      $lt: "",
    },
    ratingArr: [],
    ratingsObject: [],
    modeArr: [],
    inquiryArr: ["COACHING", "STUDENT"],
    countryArr: [],
    drawer: false,
    drawerParam: null,
    isFollowUpOverdue: false,
    updateQuickDetailsDrawer: false,
    visible1: false,
    recordId: '',
    allUsers: [],
    incentiveInquiryIds: [],
    incentiveFor: [{ id: 'OPERATION MANAGER', display: 'Operation Manager' }, { id: 'TELECALLER', display: 'Telecaller' }, { id: 'COUNSELLING', display: 'Counsellor' }, { id: 'ADMISSION', display: 'Admission' }, { id: 'VISA FILE', display: 'Visa File' }, { id: 'VISA APPROVED', display: 'Visa Approved' }]
  };

  sendMultipleIncentive = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      let inquiryIds = []
      _.each(userArr, (user) => {
        inquiryIds.push(user._id)
      })
      this.setState({ showIncentiveDrawer: true, incentiveInquiryIds: inquiryIds });
    } else {
      notification.error({
        message: "Please select atleast 1 Student.",
      });
    }
  }

  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showSMS: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeSMS = () => {
    this.setState({ showSMS: false });
  };
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showWhatsAppSms: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false });
  };
  closeEmail = () => {
    this.setState({ showEmail: false });
  };
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showEmail: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  sendEmployeeIncentives = async (recordId) => {
    let response = await Request.sendEmployeeIncentive({ _id: recordId })
    if (response.success) {
      notification.success({
        message: response.message
      })
    }
  }

  deleteStudent = async (_id) => {
    this.setState({ deleteLoading: true });
    let x = await Request.deleteStudent({ _id: _id, atLevel: "Deleted" });
    this.setState({ deleteLoading: false });
    if (x && !x.error) {
      notification.success({
        message: "Deleted Successfully",
      });
      this.table.current.reload();
    } else {
      notification.error({ message: "Try again" });
    }
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then((resp) => {
        if (resp) {
          let temp = [{ display: "---Show All---", id: "" }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name;
            vv.id = vv._id;
            temp.push(vv);
            return temp;
          }, []);
          this.setState({ counsellors: resp.data });
        }
      })
      .catch((err) => { });
  }

  openFollowUps = (record) => {
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };

    this.setState({ showFollowUp: true });
  };
  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Neutral") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
    if (val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.deskId) {
        params.atLevel = this.state.deskId;
        params.page = 1;
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
        params.page = 1;
      }

      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
        params.page = 1;
      }
      if (this.state.singleRatingFilter) {
        params["counsellingDesk.rating"] = this.state.singleRatingFilter;
      }

      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: stringToDate.setHours(0, 0, 0),
          $lt: stringToDate.setHours(23, 59, 59),
        };
      } else {
        delete params.dateOfBirth;
      }

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }
      let data = await Request.getAllStudentList({
        ...params,
        regExFilters: ["studentName", "watsupp", "mobile"],
        InquiryDate: this.state.time,
        registrationTime: this.state.registrationTime,
      });

      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false,
          };
        }
      });

      this.setState({
        count: data.total,
        allBranches: data.allBranches,
        userCheckBox: userCheckBox,
      });
      resolve(data);
    });
  };


  closeFollowUp = () => {
    this.setState({ showFollowUp: false });
  };
  returnDeskName = (val) => {
    const deskConfig = Settings.allDesks;

    let findIn = lodash.find(deskConfig, (rr) => {
      return rr.name == val;
    });

    if (findIn) {
      return (
        <div
          style={{
            backgroundColor: findIn.color,
            color: "white",
            padding: 3,
            display: "inline-block",
            fontWeight: "bold",
          }}
        >
          {Settings.deskNameObj[val]}
        </div>
      );
    } else {
      return <div>{val}</div>;
    }
  };
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;
    let userArr = lodash.filter(cloneUserCheckBox, (item) => {
      return item.isChecked
    })
    this.setState({ userCheckBox: cloneUserCheckBox, selectedCount: userArr.length });
  };
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  loadUsers = async (params, userType = 'user') => {
    if (!params) {
      params = {}
    }
    params.results = 10000;
    params.count = 10000;
    params.isStudent = false;
    params.active = true;
    params.isAdministrator = false;
    params.showAll = true;
    let response = await Request.loadDeskUser(params)
    let users = []
    _.each(response.data, (user) => {
      users.push({ id: user._id, display: user.name })
    })
    this.setState({ allUsers: users })
  }

  //   loadUsers = (params, userType = 'user') => {
  //     return new Promise(async resolve => {
  //         let activeUser = JSON.parse(localStorage.getItem('user'))
  //         if (!params) {
  //             params = {}
  //         }
  //         params.sortField = 'dateOfJoining'
  //         params.sortOrder = 'ascend'
  //         params.userBranch = activeUser.branchesManaging && activeUser.branchesManaging.length>0?{$in:activeUser.branchesManaging}:activeUser.userBranch
  //         params.active = true;
  //         params.isCounsellor = true;
  //         params.userType = { $ne : "Student"}
  //         let data = await Request.loadUser({...params, regExFilters: ['name', 'email']})
  //         this.setState({totalUser: data.total})
  //         resolve(data)
  //     })
  // }

  //   async loadUsers(){

  //     let params = {
  //         results:1000,
  //         count:1000
  //     }
  //     params.active = true;
  //     params.userType = { $ne : "Student"};
  //     params.isCounsellor = true;
  //     params.isOperationManager = true;
  //     params.isAdmission = true;
  //     params.isVisa = true;
  //     let response = await Request.loadUser({...params, regExFilters: ['name', 'email']})
  //     console.log(response)
  //   }

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(
        moment(new Date()).format("YYYY-MM-DD[T00:00:00.000Z]")
      ).isAfter(followUp.followUpDate);
    }
  };

  componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);

    let singleRatingFilter = searchParams.get("rating");
    if (singleRatingFilter) {
      this.setState({ singleRatingFilter: singleRatingFilter });
    }
  }

  async componentDidMount() {
    await this.loadUsers()
    await this.getAllRatings();
    await this.getAllSource();
    await this.getAllTestTypes();
    let {
      data: allCounsellor,
    } = await Request.loadCounsellorListForStudentRights({
      results: 10000,
    });
    this.setState({
      allCounsellor,
    });

    let {
      data: allOperationManager,
    } = await Request.getOperationManagerListForStudentRights({
      results: 10000,
    });
    this.setState({
      allOperationManager,
    });
  }
  getAllTestTypes = async () => {
    let response = await Request.getAllTestTypes({
      results: 1000,
      count: 1000
    });
    if (response && response.data) {
      let testTypeList = [];
      testTypeList.push({ value: 'NO', text: 'Never' })
      response.data.map((testTypeData) => {
        testTypeList.push({ value: testTypeData.testType, text: testTypeData.testType })
      })
      this.setState({
        testTypeList: testTypeList
      });
    }
  }
  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000,
    });
    let sourceObject = [];
    response.data &&
      response.data.map((source) => {
        sourceObject.push(source.sourceName);
      });
    this.setState({ modeArr: sourceObject });
  };

  handleStudentMove = async (data) => {
    let response = await Request.moveStudentToVisitorVisa(data);
    if (!response.error) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
  };

  sendIncentiveToEmployee = async (recordId) => {
    let { doc } = await Request.getInquiry(recordId)
    let incentiveFor = [];
    if (doc.atLevel === 'Claim Desk' || doc.atLevel === "Archive Desk") {
      incentiveFor = [{ id: 'OPERATION MANAGER', display: 'Operation Manager' }, { id: 'TELECALLER', display: 'Telecaller' }, { id: 'COUNSELLING', display: 'Counsellor' }, { id: 'ADMISSION', display: 'Admission' }, { id: 'VISA FILE', display: 'Visa File' }, { id: 'VISA APPROVED', display: 'Visa Approved' }]
    } else if (doc.atLevel === 'Visa Desk' && doc.visaDesk.fileStatus === "Visa File Dispatched") {
      incentiveFor = [{ id: 'OPERATION MANAGER', display: 'Operation Manager' }, { id: 'TELECALLER', display: 'Telecaller' }, { id: 'COUNSELLING', display: 'Counsellor' }, { id: 'ADMISSION', display: 'Admission' }, { id: 'VISA FILE', display: 'Visa File' }]
    } else if (doc.atLevel === "Application Desk") {
      incentiveFor = [{ id: 'OPERATION MANAGER', display: 'Operation Manager' }, { id: 'TELECALLER', display: 'Telecaller' }, { id: 'COUNSELLING', display: 'Counsellor' }]
    } else if (doc.atLevel === "Visa Desk" && doc.visaDesk.fileStatus !== 'Visa File Dispatched' || doc.atLevel === "Visa Desk" && !doc.visaDesk.fileStatus) {
      incentiveFor = [{ id: 'OPERATION MANAGER', display: 'Operation Manager' }, { id: 'TELECALLER', display: 'Telecaller' }, { id: 'COUNSELLING', display: 'Counsellor' }, { id: 'ADMISSION', display: 'Admission' }]
    } else if (doc.atLevel === "Registration Desk") {
      incentiveFor = [{ id: 'OPERATION MANAGER', display: 'Operation Manager' }, { id: 'TELECALLER', display: 'Telecaller' }, { id: 'COUNSELLING', display: 'Counsellor' }]
    }
    this.setState({ recordId: recordId, showIncentiveDrawer: true, incentiveFor })
  }

  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000,
    });
    let ratingsObject = [];
    response.data &&
      response.data.map((rating) => {
        ratingsObject[rating._id] = rating;
      });
    this.setState({ ratingArr: response.data, ratingsObject: ratingsObject });
  };

  loadCountry(callback) {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          lodash.each(resp.data, (vv) => {
            temp.push({
              text: vv.countryName,
              value: vv.countryName,
            });
          });
          return callback(temp);
        } else {
          return callback([]);
        }
      })
      .catch((err) => {
        return callback([]);
      });
  }

  chooseRangerPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        time: {
          key: "time",
          $gte: date[0],
          $lt: date[1],
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };

  chooseRegistrationPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        registrationTime: {
          $gte: date[0],
          $lt: date[1],
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };

  reload = () => {
    this.table.current.reload();
  };

  closeIncentiveDrawer() {
    this.setState({ recordId: '', showIncentiveDrawer: false, incentiveInquiryIds: [] })
  }

  handleIncentiveSubmit = e => {
    const { dispatch, form } = this.props;
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        if (this.state.recordId !== '') {
          values.inquiryId = this.state.recordId;
        } else {
          values.inquiryId = this.state.incentiveInquiryIds;
        }
        let response = await Request.sendIncentiveToEmployee(values)
        if (response.success) {
          notification.success({
            message: response.message
          })
        }
        this.closeIncentiveDrawer()
      }
    })
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {

        let values = _.clone(valData)

        let x = null
        x = await Request.addInquiryThroughExcel(values.excelFile[0].response)

        if (!x.error) {
          notification.success({
            message: x.message
          })

          this.setState({ visible1: false })
          this.table.current.reload()
        } else {
          notification.error({
            message: x.message

          })
        }
      }
    })
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState(
      {
        isFollowUpOverdue: isFollowUpOverdue,
      },
      () => {
        this.table.current.reload();
      }
    );
  }

  render() {
    const { dispatch } = this.props;
    const {
      drawerParam,
      drawer,
      allDesks,
      inquiryArr,
      ratingsObject,
      allCounsellor = [],
      allOperationManager = [],
      countryArr = [],
      deleteLoading,
      allBranches = [],
      deskColor,
      userCheckBox,
      ratingArr,
      modeArr,
      deskNameObj,
      counsellors,
      testTypeList,
      showIncentiveDrawer,
      recordId,
      incentiveFor,
      allUsers,
    } = this.state;


    const inputTypes = {
      fields: [
        { label: 'Choose Excel File', key: 'excelFile', type: 'file', required: true }
      ]
    }
    const incentiveInputTypes = {
      fields: [
        {
          label: 'Select User', key: 'userId', type: 'select', required: true, options: allUsers, showSearch: true, onChange: v => {
            this.props.form.setFieldsValue({ userId: v })
          }
        },
        {
          label: 'Incentive For', key: 'incentiveFor', type: 'select', required: true, options: incentiveFor, onChange: v => {
            this.props.form.setFieldsValue({ incentiveFor: v })
          }
        },
        {
          label: 'Verify Consultancy?', key: 'verifyConsultancy', type: 'select', required: true, options: [{ id: 'true', display: 'Yes' }, { id: 'false', display: 'No' }], onChange: v => {
            this.props.form.setFieldsValue({ verifyConsultancy: v })
          }
        }
      ]
    }
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 }
      }
    }

    const {
      form: { getFieldDecorator, getFieldValue }
    } = this.props


    let columns = [
      {
        title: "Action ",
        key: "operation",
        dataindex: "operation",
        right: rightAuth.checkRights("actionColumn.view"),
        width: 90,
        maxWidth: 200,
        render: (text, record) => (
          <React.Fragment>
            <span className={styles.userSelectCheckbox}>
              <Checkbox
                checked={
                  userCheckBox[record._id]
                    ? userCheckBox[record._id].isChecked
                    : false
                }
                onChange={(y) => {
                  let previousPayments = record.payments[record.payments.length - 1]
                  if (y.target.checked && !previousPayments || y.target.checked && previousPayments.balance > 0) {
                    notification.error({
                      message: `${record.id}, Incentive Can\'t Disbursed! Consultancy Fee Pending! ${previousPayments && previousPayments.balance ? previousPayments.balance : ''}`
                    })
                  }
                  this.selectUser(y, record._id);
                }}
              />
            </span>
            <span>
              <Tooltip title="Send Incentive To All">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  icon="edit"
                  onClick={() => {
                    let previousPayments = record.payments[record.payments.length - 1]
                    if (!previousPayments || previousPayments.balance > 0) {
                      notification.error({
                        message: `${record.id}, Incentive Can\'t Disbursed! Consultancy Fee Pending! ${previousPayments && previousPayments.balance}`
                      })
                    }
                    this.sendEmployeeIncentives(record._id)
                  }}
                >
                </Button>
              </Tooltip>
            </span>
            <span>
              <Tooltip title="Send Incentive To Single Employee">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  icon="forward"
                  onClick={() => {
                    let previousPayments = record.payments[record.payments.length - 1]
                    if (!previousPayments || previousPayments.balance > 0) {
                      notification.error({
                        message: `${record.id}, Incentive Can\'t Disbursed! Consultancy Fee Pending! ${previousPayments && previousPayments.balance}`
                      })
                    }
                    this.sendIncentiveToEmployee(record._id)
                  }}
                >
                </Button>
              </Tooltip>
            </span>
          </React.Fragment>
        ),
      },
      {
        title: "ID",
        key: "id",
        width: 100,
        dataIndex: "id",
        sorter: true,
        searchTextName: "id",
        right: rightAuth.checkRights("idColumn.view"),
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        width: 110,
        dataIndex: "studentName",
        sorter: true,
        searchTextName: "studentName",
        right: rightAuth.checkRights("nameColumn.view"),
        filterRegex: true,
        render: (item, record) => {
          return (
            <React.Fragment>
              <div
                className={
                  this.followUpExtendedDate(
                    record.followUp ? record.followUp : ""
                  )
                    ? styles.followUpExtendedDate
                    : ""
                }
              >
                <Tooltip>
                  <a
                    className={styles.btn}
                    target={"_blank"}
                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                  >
                    {item}
                  </a>
                </Tooltip>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        title: "At Stage",
        key: "atLevel",
        dataIndex: "atLevel",
        width: 150,
        sorter: true,
        right: rightAuth.checkRights("atStageColumn.view"),
        render: (val, record) => {
          return this.returnDeskName(val);
        },
      },
      {
        title: "Student Register From ",
        width: 180,
        key: "studentRegisterFrom",
        dataIndex: "studentRegisterFrom",
        right: rightAuth.checkRights("studentRegisterFromColumn.view"),
        render: (val, record) => {
          return (
            <div>
              {record.studentRegisterFrom
                ? record.studentRegisterFrom
                : "Reception Desk"}
            </div>
          );
        },
      },
      {
        title: "Registration Date",
        width: 100,
        key: "moveDeskDate.moveToRegistrationDesk",
        dataIndex: "moveDeskDate.moveToRegistrationDesk",
        right: rightAuth.checkRights("registrationDateColumn.view"),
        width: 140,
        render: (text, record) => {
          return <div>{text ? moment(text).format("lll") : ""}</div>;
        },
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        width: 110,
        right: rightAuth.checkRights("counsellorColumn.view"),
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Operation Manager",
        key: "operationManagerId",
        right: rightAuth.checkRights("operationManagerColumn.view"),
        width: 110,
        filters: allOperationManager.map((x) => ({
          value: x._id,
          text: x.name,
        })),
        render: (text, record) => {
          return (
            <div>
              {record.operationManagerId ? record.operationManagerId.name : ""}
            </div>
          );
        },
      },
      {
        title: "Branch",
        width: 100,
        key: "studentBranchId",
        right: rightAuth.checkRights("branchColumn.view"),
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "Preference",
        key: "preference",
        width: 110,
        searchTextName: "preference",
        right: rightAuth.checkRights("preferenceColumn.view"),
        filterRegex: true,
        render: (val, row) => {
          return row.totalPreference ? (
            <ul className={common.ul}>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val.country}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        right: rightAuth.checkRights("lastUpdatedByColumn.view"),
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },

    ];
    columns = lodash.filter(columns, (x) => {
      return x.right == true;
    });

    return (
      <PageHeaderWrapper
        title={` STUDENTS LIST : ${this.state.count} `}
        followUpsCallback={this.followUpsCallback}
      >
        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}

        {drawer && (
          <ChangeBranch
            param={drawerParam}
            onClose={() => {
              this.setState({ drawer: false }, () => {
                this.table.current.reload();
              });
            }}
          />
        )}

        {this.state.updateQuickDetailsDrawer && (
          <ChangeQuickDetails
            param={drawerParam}
            onClose={() => {
              this.setState({ updateQuickDetailsDrawer: false }, () => {
                this.table.current.reload();
              });
            }}
          />
        )}

        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS
            counsellingData={counsellingData}
            onClose={this.closeWhatsSMS}
          />
        ) : null}

        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}

        {this.state.showEmail ? (
          <EmailDrawer
            counsellingData={counsellingData}
            onClose={this.closeEmail}
          />
        ) : null}
        <Card style={{ marginBottom: 10 }}>
          <Col span={9}>
            <Button
              type="primary"
              className={styles.btn}
              onClick={() => this.sendMultipleIncentive()}
            >
              Send Incentives
            </Button>
          </Col>
        </Card>

        <Card bordered={true}>
          <h1>Selected:- {this.state.selectedCount}</h1>
          <TableComp
            id={"allstudents"}
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params, columns)}
            extraProps={{ scroll: { x: 1800 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
        {this.state.visible1 && <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              visible1: false
            })
          }}
          visible={this.state.visible1}
          width={500}>
          <div>
            <Card bordered={true}>
              <div>

                <Form onSubmit={this.handleSubmit} {...formItemLayout} style={{ marginTop: 8 }}>
                  <GetAllFormFields apiurl={LAPI_URL}
                    inputSchema={inputTypes}
                    getFieldDecorator={getFieldDecorator} />

                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginLeft: '10%' }}
                    loading={this.state.loading}>
                    UPLOAD

                  </Button>

                  <a href={'../../../rawInquiry.xlsx'} download={'sample.xlsx'}>
                    <Button
                      type="default"
                      style={{ marginLeft: '10%' }}
                      loading={this.state.loading}>
                      DOWNLOAD SAMPLE FILE
                    </Button>
                  </a>
                </Form>

              </div>


            </Card>
          </div>
        </Drawer>}

        {showIncentiveDrawer && <Drawer
          title={
            <div>
              <React.Fragment>
                Add User Incentive
              </React.Fragment>
            </div>
          }
          placement="right"
          closable={true}
          onClose={() => this.closeIncentiveDrawer()}
          width={600}
          visible={showIncentiveDrawer}>
          <Card>
            <Form onSubmit={this.handleIncentiveSubmit} style={{ marginTop: 8 }}>
              <div>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={incentiveInputTypes}
                  getFieldDecorator={getFieldDecorator}
                />
              </div>
              <Row style={{ marginTop: '20px' }}>
                <Col span={8} />
                <Col span={8}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: 10 }}
                    loading={this.props.loading}>
                    SAVE
                  </Button>
                </Col>
                <Col span={8} />
              </Row>
            </Form>
          </Card>
        </Drawer>}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviousIncentive);
